// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 21:08:20

export default {
  "id": "traffic-jam-hop-on",
  "slug": "traffic-jam-hop-on",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/ff6e292a8036469fa4cac548f759b631-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/ff6e292a8036469fa4cac548f759b631/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Traffic Jam Hop On",
      "description": "In Traffic Jam: Hop On, challenge your strategy thinking and quick reflexes! This wonderful puzzle game will take you into a colorful parking lot. Your task is to help all kinds of vehicles get out of traffic jams and start smoothly.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "car",
        "escape",
        "parking"
      ]
    },
    "zh-CN": {
      "title": "交通拥堵跳上",
      "description": "在《交通堵塞：跳上去》中，挑战你的策略思维和快速反应！这款精彩的益智游戏将带你进入一个五彩斑斓的停车场。你的任务是帮助各种车辆摆脱交通堵塞，顺利起步。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "拼图"
      ],
      "tags": [
        "汽车",
        "逃脱",
        "停车"
      ]
    },
    "zh-TW": {
      "title": "交通擁堵跳上",
      "description": "在《交通大亂：上車吧》挑戰你的策略思維和快速反應！這款精彩的益智遊戲將帶你進入一個色彩繽紛的停車場。你的任務是幫助各種車輛脫離交通堵塞，並順暢行駛。",
      "instructions": "滑鼠點擊或觸控開始遊戲",
      "genres": [
        "謎題"
      ],
      "tags": [
        "車",
        "逃離",
        "停車"
      ]
    },
    "zh-HK": {
      "title": "交通擠擠跳上",
      "description": "在《交通擁堵：跳上》，挑戰你的策略思維和快速反應！這款精彩的小遊戲將帶你進入一個色彩繽紛的停車場。你的任務是幫助各種車輛解決交通擁堵，順暢行駛。",
      "instructions": "用鼠標點擊或觸控以遊玩",
      "genres": [
        "謎題"
      ],
      "tags": [
        "車輛",
        "逃離",
        "停車"
      ]
    },
    "ja": {
      "title": "交通渋滞乗り込み",
      "description": "トラフィックジャム：ハプオンで、あなたの戦略的な思考と素早い反応を挑戦しましょう！この素晴らしいパズルゲームでは、カラフルな駐車場に引き込まれます。あなたのタスクは、様々な車両が渋滞から抜け出し、スムーズに走るよう支援することです。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "パズル"
      ],
      "tags": [
        "車",
        "逃走",
        "駐車"
      ]
    },
    "ko": {
      "title": "교통 혼잡 점프 온",
      "description": "트래픽 잴: 힙온에서 전략적 사고와 빠른 반응을 도전하세요! 이 환상적인 퍼즐 게임은 다양한 색상의 주차장으로 당신을 안내합니다. 당신의 임무는 모든 유형의 차량이 교통체증에서 벗어나 원활하게 운행할 수 있도록 도와야 합니다.",
      "instructions": "마우스 클릭 또는 탭하여 게임 시작",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "차",
        "탈출",
        "주차"
      ]
    },
    "fr": {
      "title": "Roulement de bouchon - Montez à bord",
      "description": "Dans Traffic Jam: Hop On, challengez votre pensée stratégique et vos réflexes rapides ! Ce merveilleux jeu de puzzle vous emmènera dans un parking coloré. Votre tâche est d'aider tous types de véhicules à sortir des embouteillages et à circuler sans encombre.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "car : voiture\nescape : évasion\nparking : parking"
      ]
    }
  }
};
